/* c8 ignore start */
import customers from "./customers";
import courses from "./courses";
import cards from "./cards";

export default {
  customers,
  courses,
  cards,
};
/* c8 ignore end */
